import { themeColors } from '@/lib/config/colors';
import { useTheme } from '@/lib/utils/themeContext';

const Styles = () => {
  const theme = useTheme();

  return (
    <style>
      {`
      html,
      :root {
        --theme-color: ${themeColors[theme.color || 'purple'][600].hex};
        --headline-color: var(--theme-color);
        --plyr-color-main: var(--theme-color);
      }
    `}
    </style>
  );
};

export default Styles;
